import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class NewsService {
  getNewsList() {
    return axios.get(API_URL + '/news-and-press/published')
  }
  getNewsInformation(Id){
    return axios.get(API_URL + '/news-and-press/' + Id)
  }
}

export default new NewsService()
